export default {
  user: null,
  parentUser: null,
  cities: [],
  permissions: {},
  permissionIds: [],
  loading: false,
  username: '',
  logInAsMultiLocationUser: false,
  MultiLocationUser: null,
  growerAndProcessorRoleGroup: []
}
